import React, { Component } from "react";
import SubmitFeed from "./Elements/SubmitFeed";
import InputField from "./Elements/InputField";
import { isAppleSafari, showAddAccountAlertNew, TOAST_ERROR, isAccountConnected } from "../../../../../../../../../utils";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";
import ConnectNetwork from "../../../../../../Feeds/AddFeeds/Elements/ConnectNetwork";
import { connect } from "react-redux";
import { getConnectedAccount } from "../../../../../../../../../actions/addFeedActions";

const NETWORK_ID = 32;
const initialErrors = {
    hashtagError: false,
    handleError: false,
    keywordError: false
}
const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class ThreadFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            handle: "",
            hashtag: "",
            keyword: "",
            ...initialErrors,
            accountId: null,
            loading: false
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
        if (this.props.getConnectedAccount) {
            this.props.getConnectedAccount(NETWORK_ID);
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, (connectId) => {
                this.setState({ accountId: connectId ?? null }, this.onSubmit);
                if (this.props.getConnectedAccount) {
                    this.props.getConnectedAccount(NETWORK_ID);
                }
            }, localStorage.getItem('ownerId'));
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, [`${e.target.name}Error`]: false });

    onSubmit = (isDisabledClick) => {
        const { updateStep, selectedFilterId, connectedAcc } = this.props;
        const { hashtag, handle, keyword, accountId } = this.state;

        const isAccConnected = isAccountConnected({ connectedAcc, accountId });

        if ([4, 5].includes(selectedFilterId)) {
            if (!isAccConnected) {
                TOAST_ERROR("Please connect your Threads Account to proceed");
                return;
            }
        }

        const errorFields = {
            [1]: 'keywordError',
            [2]: 'hashtagError',
            [3]: 'handleError',
        };
        const errorField = errorFields[selectedFilterId];
        if (![4, 5].includes(selectedFilterId) && !this.state[errorField] && !(hashtag || handle || keyword)) {
            this.setState({ [errorField]: true });
            if (isDisabledClick) {
                TOAST_ERROR('Please enter required details to collect content');
            }
        } else {
            const finalAccountId = accountId || (connectedAcc && connectedAcc[0] ? connectedAcc[0].ConnectedAccounts?.id : null);
            if (!finalAccountId && [4, 5].includes(selectedFilterId)) {
                showAddAccountAlertNew({ id: NETWORK_ID, name: 'Threads' }, "addFeed");
                return;
            }
            var obj = {
                accountId: finalAccountId,
                feedText: "",
                productId: 4,
                moderation: 0,
                networkId: NETWORK_ID,
                filter: selectedFilterId,
            }

            if (selectedFilterId == 1) obj['feedText'] = keyword;
            else if (selectedFilterId == 2) obj['feedText'] = hashtag.split('#').join('');
            else if (selectedFilterId == 3) obj['feedText'] = handle.split('@').join('');

            this.setState({ loading: true, ...initialErrors });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { hashtag, handle, keyword, hashtagError, handleError, keywordError, loading } = this.state;
        const { selectedFilterId } = this.props;

        const isSubmitDisabled = selectedFilterId == 1 ? !keyword.trim()
            : selectedFilterId == 2 ? !hashtag.trim()
                : selectedFilterId == 3 ? !handle.trim()
                    : false;

        return (
            <div className="ob-feed-form-wrapper w-100">
                {[1, 2, 3].includes(selectedFilterId) ? (
                    <div className="selectSource-right mb-3">
                        <div className="position-relative d-flex custom-input">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-${selectedFilterId == 1 ? "font" : selectedFilterId == 2 ? "hashtag" : "at"}`}></i>
                            </span>
                            <InputField name={selectedFilterId == 1 ? "keyword" : selectedFilterId == 2 ? "hashtag" : "handle"} placeholder={selectedFilterId == 1 ? "Enter keyword here.." : selectedFilterId == 2 ? "Enter hashtag here.." : "Enter handle here.."} className="form-control p-3" value={selectedFilterId == 1 ? keyword : selectedFilterId == 2 ? hashtag : handle} onChangeHandler={this.onTextChange} />
                        </div>
                        {((selectedFilterId == 1 && keywordError) || (selectedFilterId == 2 && hashtagError) || (selectedFilterId == 3 && handleError)) && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required.</span>}
                    </div>
                ) : <ConnectNetwork id={NETWORK_ID} name={"Threads"} />}
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={isSubmitDisabled} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getConnectedAccount: (networkId) => dispatch(getConnectedAccount(networkId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThreadFeed);